const studentProfiles = [
  {
    knowreUserId: 16722,
    userName: '오유진',
    userAge: 'P5',
    userImgUrl:
      'https://constellation-demo.s3.ap-northeast-2.amazonaws.com/student-profile/4.png',
  },
  {
    knowreUserId: 20530,
    userName: '최석원',
    userAge: 'P5',
    userImgUrl:
      'https://constellation-demo.s3.ap-northeast-2.amazonaws.com/student-profile/14.png',
  },
  {
    knowreUserId: 26724,
    userName: '이도현',
    userAge: 'P3',
    userImgUrl:
      'https://constellation-demo.s3.ap-northeast-2.amazonaws.com/student-profile/12.png',
  },
  {
    knowreUserId: 30342,
    userName: '박민교',
    userAge: 'P5',
    userImgUrl:
      'https://constellation-demo.s3.ap-northeast-2.amazonaws.com/student-profile/16.png',
  },
  {
    knowreUserId: 49056,
    userName: '김예원',
    userAge: 'P5',
    userImgUrl:
      'https://constellation-demo.s3.ap-northeast-2.amazonaws.com/student-profile/13.png',
  },
  {
    knowreUserId: 55830,
    userName: '윤혜지',
    userAge: 'P6',
    userImgUrl:
      'https://constellation-demo.s3.ap-northeast-2.amazonaws.com/student-profile/3.png',
  },
  {
    knowreUserId: 68978,
    userName: '이슬',
    userAge: 'P5',
    userImgUrl:
      'https://constellation-demo.s3.ap-northeast-2.amazonaws.com/student-profile/15.png',
  },
  {
    knowreUserId: 87491,
    userName: '최효준',
    userAge: 'P4',
    userImgUrl:
      'https://constellation-demo.s3.ap-northeast-2.amazonaws.com/student-profile/6.png',
  },
  {
    knowreUserId: 105688,
    userName: '김우진',
    userAge: 'P5',
    userImgUrl:
      'https://constellation-demo.s3.ap-northeast-2.amazonaws.com/student-profile/8.png',
  },
  {
    knowreUserId: 111586,
    userName: '박범주',
    userAge: 'P4',
    userImgUrl:
      'https://constellation-demo.s3.ap-northeast-2.amazonaws.com/student-profile/11.png',
  },
  {
    knowreUserId: 120952,
    userName: '최은우',
    userAge: 'P5',
    userImgUrl:
      'https://constellation-demo.s3.ap-northeast-2.amazonaws.com/student-profile/1.png',
  },
  {
    knowreUserId: 121909,
    userName: '김지유',
    userAge: 'P6',
    userImgUrl:
      'https://constellation-demo.s3.ap-northeast-2.amazonaws.com/student-profile/10.png',
  },
  {
    knowreUserId: 136068,
    userName: '안성연',
    userAge: 'P2',
    userImgUrl:
      'https://constellation-demo.s3.ap-northeast-2.amazonaws.com/student-profile/9.png',
  },
  {
    knowreUserId: 139930,
    userName: '이하정',
    userAge: 'P4',
    userImgUrl:
      'https://constellation-demo.s3.ap-northeast-2.amazonaws.com/student-profile/5.png',
  },
];

export default studentProfiles;
